import { CSS, Transform } from '@dnd-kit/utilities'
import { Box } from '@pinchenterprisesnpm/friday-ui'
import { TypeOrNull, TypeOrUndefined } from '@src/models/Common'
import styled from 'styled-components'

export const PositionRelativeBox = styled(Box)`
  position: relative;
`
export const GrabWrapper = styled(Box)`
  cursor: grab;
  display: flex;
  align-items: center;
`

export const sortableWrapperStyle = (
  isDragging: boolean,
  transition: TypeOrUndefined<string>,
  transform: TypeOrNull<Transform>
) => ({
  transition: transition,
  transform: CSS.Transform.toString(transform),
  opacity: isDragging ? 0.5 : 1,
})
